import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ShowsService } from "../../services/shows.service";


@Component({
    selector: 'app-user-edit',
    templateUrl: './edit-user.component.html',
    styleUrl: './edit-user.component.scss',
    standalone: false
})
export class EditUserComponent {
  title: string = '';
  show: any;
  processing = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<EditUserComponent>,
    public showsService: ShowsService
  ) {
    this.title = data.title;
    this.show = data.value;

  }
  save() {
    this.processing = true;
    this.showsService.UpdateUsers(this.show.UUID, this.show).subscribe({
      next: (response) => {
        console.log('User updated successfully:', response);
        this.close();
      },
    });
  }
  close() {
    this.dialogRef.close('cancelDialog');
  }
}
